import React from "react";
import PropTypes from "prop-types";
import Modal from "../../Elements/Modal/Modal";
import MainButton from "../../Elements/MainButton/MainButton";
import SecondButton from "../../Elements/SecondButton/SecondButton";
import "./AddedToCartModal.css";

const AddedToCartModal = ({ isOpen, onClose, onGoToCart, item, quantity }) => {
  if (!item) return null;

  const currency = (value, cur = "USD") => {
    if (value == null) return "";
    return `${value.toFixed(2)} ${cur}`;
  };

  const totalPrice = (item.price || 0) * (quantity || 1);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Added to cart"
      actions={
        <>
          <SecondButton onClick={onClose}>Continue shopping</SecondButton>
          <MainButton onClick={onGoToCart}>Go to cart</MainButton>
        </>
      }
    >
      <div className="added-to-cart-body">
        <p className="added-to-cart-text">Your eSIM plan has been added to your cart.</p>

        <div className="added-to-cart-item">
          <div className="added-to-cart-item__info">
            <div className="added-to-cart-item__name">{item.name}</div>
            {/* <div className="added-to-cart-item__meta">
              {item.gigabytes && <span>{item.gigabytes} GB</span>}
              {item.duration && <span>{item.duration} days</span>}
              {quantity > 1 && <span>Qty: {quantity}</span>}
            </div> */}
          </div>

          <div className="added-to-cart-item__price">{currency(totalPrice, item.currency)}</div>
        </div>
      </div>
    </Modal>
  );
};

AddedToCartModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onGoToCart: PropTypes.func.isRequired,
  item: PropTypes.object,
  quantity: PropTypes.number,
};

export default AddedToCartModal;
